import { COMPLIANCE_DOCUMENT_TYPE_VALUES } from '../constants';
import { ComplianceDocumentTypes } from '../types';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

const ComplianceDocumentTypeField = ({ source = 'complianceType' }: FieldProps) => {
  const { getValue } = useFieldHelper<ComplianceDocumentTypes>({ source });
  const complianceType = getValue();

  return <>{complianceType ? COMPLIANCE_DOCUMENT_TYPE_VALUES[complianceType] : ''}</>;
};

export default ComplianceDocumentTypeField;
